module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "reportOpen": _vm.reportOpen,
        "reportNumber": _vm.appraisalreport.number,
        "versionNumber": _vm.appraisalreport.version,
        "realEstateId": _vm.ad.id,
        "reportId": _vm.appraisalreport.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Ad')) + " "), (_vm.ad.ad_date) ? _c('span', [_vm._v(_vm._s(_vm.$t('from')) + " " + _vm._s(_vm.formatted_ad_date))]) : _vm._e(), _vm._v(" "), (_vm.ad.street_name) ? _c('span', [_vm._v(_vm._s(_vm.$t('at')) + " " + _vm._s(_vm.ad.street_name))]) : _vm._e(), (_vm.ad.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.ad.street_number))]) : _vm._e(), (_vm.ad.municipality) ? _c('span', [_vm._v(", " + _vm._s(_vm.ad.municipality.name_ine))]) : _vm._e(), _vm._v(" "), (_vm.ad.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.ad.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.ad.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.ad.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.identification_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [(_vm.ad.url) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenAd($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "external-link",
        "text": _vm.open_ad_button_text,
        "icon_color": "#004f92",
        "text_color": "#004f92",
        "border_color": "lightgray"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Country')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.countryValue,
        "options": _vm.countryOptions,
        "track-by": "iso_3166_alpha2_code",
        "label": 'name_en',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_country_option
      },
      model: {
        value: (_vm.ad.country),
        callback: function($$v) {
          _vm.ad.country = $$v
        },
        expression: "ad.country"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.ad.country) ? _c('div', {
      staticClass: "ms-container"
    }, [(_vm.ad.country.name_en === 'Spain') ? _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Province'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.provinceValue,
        "options": _vm.spanishProvinceOptions,
        "track-by": "id",
        "label": 'name_ine',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_province_option
      },
      model: {
        value: (_vm.ad.province),
        callback: function($$v) {
          _vm.ad.province = $$v
        },
        expression: "ad.province"
      }
    })], 1) : _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Province')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.province),
        expression: "ad.province"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.province)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.province = $event.target.value
        }, _vm.set_ad_province]
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.ad.province) ? _c('div', {
      staticClass: "ms-container"
    }, [(_vm.ad.country.name_en === 'Spain') ? _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Municipality'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.municipalityValue,
        "options": _vm.object_to_array(_vm.ad_municipalities),
        "track-by": "id",
        "label": 'name_ine',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_municipality_option
      },
      model: {
        value: (_vm.ad.municipality),
        callback: function($$v) {
          _vm.ad.municipality = $$v
        },
        expression: "ad.municipality"
      }
    })], 1) : _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Municipality')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.municipality),
        expression: "ad.municipality"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.municipality)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.municipality = $event.target.value
        }, _vm.set_ad_municipality]
      }
    })])]) : _vm._e()]), _vm._v(" "), (_vm.ad.municipality) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Street_name'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.street_name),
        expression: "ad.street_name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.street_name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.street_name = $event.target.value
        }, _vm.set_ad_street_name]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Street_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.street_number),
        expression: "ad.street_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "1",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.street_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.street_number = $event.target.value
        }, _vm.set_ad_street_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor_name'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.floor),
        expression: "ad.floor"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.floor)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.floor = $event.target.value
        }, _vm.set_ad_floor]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Height_situation'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.floor_number),
        expression: "ad.floor_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.floor_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.floor_number = $event.target.value
        }, _vm.set_ad_floor_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor_type'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.floor_typeValue,
        "options": _vm.floor_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_floor_type
      },
      model: {
        value: (_vm.ad.floor_type),
        callback: function($$v) {
          _vm.ad.floor_type = $$v
        },
        expression: "ad.floor_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Door'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.door),
        expression: "ad.door"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.door)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.door = $event.target.value
        }, _vm.set_ad_door]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Staircase'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.staircase),
        expression: "ad.staircase"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.staircase)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.staircase = $event.target.value
        }, _vm.set_ad_staircase]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Block'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.block),
        expression: "ad.block"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.block)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.block = $event.target.value
        }, _vm.set_ad_block]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_address')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.ad_address),
        expression: "ad.ad_address"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.ad_address)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.ad_address = $event.target.value
        }, _vm.set_ad_ad_address]
      }
    })])])]) : _vm._e()]), _vm._v(" "), (this.ad.municipality && this.ad.street_name && this.ad.street_number) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Geolocation')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGeolocate($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onGeolocate($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Geolocate')))], 1)])]), _vm._v(" "), (_vm.google_geocode_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Latitude'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.lat),
        expression: "ad.lat"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.lat)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.lat = $event.target.value
        }, _vm.set_ad_lat],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Longitude'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.lng),
        expression: "ad.lng"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.lng)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.lng = $event.target.value
        }, _vm.set_ad_lng],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Postal_code'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.postal_code),
        expression: "ad.postal_code"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.postal_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.postal_code = $event.target.value
        }, _vm.set_ad_postal_code]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("X EPSG:25831"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.epsg25831_x),
        expression: "ad.epsg25831_x"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.epsg25831_x)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.epsg25831_x = $event.target.value
        }, _vm.set_ad_epsg25831_x],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Y EPSG:25831"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.epsg25831_y),
        expression: "ad.epsg25831_y"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.epsg25831_y)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.epsg25831_y = $event.target.value
        }, _vm.set_ad_epsg25831_y],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('span', {
      staticClass: "help"
    }, [_c('i', [_vm._v("Aquesta geolocalització es correspon a l'adreça:")]), _vm._v(" " + _vm._s(_vm.ad.google_formatted_address) + ", (" + _vm._s(_vm.ad.geohash) + ")")])])])]) : _vm._e(), _vm._v(" "), (this.ad.epsg25831_x && this.ad.epsg25831_y) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Census_section')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestCensusSectionInfo($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onRequestCensusSectionInfo($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Census_section')))], 1)])]), _vm._v(" "), (_vm.icc_census_section_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Census_section_code'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.census_section_code),
        expression: "ad.census_section_code"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.census_section_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.census_section_code = $event.target.value
        }, _vm.set_ad_census_section_code]
      }
    })])])]) : _vm._e(), _vm._v(" "), (this.ad.epsg25831_x && this.ad.epsg25831_y) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Cadastral_data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestCadastralReferenceSuggestion($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onRequestCadastralReferenceSuggestion($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Cadastral_reference')))], 1)])]), _vm._v(" "), (_vm.cadaster_ref_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_reference'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.cadastral_reference),
        expression: "ad.cadastral_reference"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "maxlength": "20",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.cadastral_reference)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.cadastral_reference = $event.target.value
        }, _vm.set_ad_cadastral_reference]
      }
    })]), _vm._v(" "), (_vm.ad.cadastral_reference) ? _c('div', [(_vm.ad.cadastral_reference.length > 0 && _vm.ad.cadastral_reference.length < 20) ? _c('message', {
      attrs: {
        "text": _vm.cad_ref_error_text_01,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenCadastralMap($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenCadastralMap($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Open')) + " " + _vm._s(_vm.$t('Cadastral_Map')))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_year'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.construction_year),
        expression: "ad.construction_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.construction_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.construction_year = $event.target.value
        }, _vm.set_ad_construction_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_area'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.cadastral_area),
        expression: "ad.cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.cadastral_area = $event.target.value
        }, _vm.set_ad_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_data_check'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.cadastral_data_check),
        expression: "ad.cadastral_data_check"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.cadastral_data_check) ? _vm._i(_vm.ad.cadastral_data_check, null) > -1 : (_vm.ad.cadastral_data_check)
      },
      on: {
        "input": _vm.set_ad_cadastral_data_check,
        "__c": function($event) {
          var $$a = _vm.ad.cadastral_data_check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.cadastral_data_check = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.cadastral_data_check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.cadastral_data_check = $$c
          }
        }
      }
    })])])]) : _c('div', [(this.ad.municipality && this.ad.street_name && this.ad.street_number) ? _c('message', {
      attrs: {
        "text": _vm.epsg_missing_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Registry_data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("IDUFIR"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.registry_idufir),
        expression: "ad.registry_idufir"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.registry_idufir)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.registry_idufir = $event.target.value
        }, _vm.set_ad_registry_idufir]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Info_source')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_data_type'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.ad_data_typeValue,
        "options": _vm.ad_data_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_ad_data_type
      },
      model: {
        value: (_vm.ad.ad_data_type),
        callback: function($$v) {
          _vm.ad.ad_data_type = $$v
        },
        expression: "ad.ad_data_type"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.ad_typeValue,
        "options": _vm.ad_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_ad_type
      },
      model: {
        value: (_vm.ad.ad_type),
        callback: function($$v) {
          _vm.ad.ad_type = $$v
        },
        expression: "ad.ad_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.property_typeValue,
        "options": _vm.property_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_property_type
      },
      model: {
        value: (_vm.ad.property_type),
        callback: function($$v) {
          _vm.ad.property_type = $$v
        },
        expression: "ad.property_type"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Dwelling_type'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.dwelling_typeValue,
        "options": _vm.dwelling_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_dwelling_type
      },
      model: {
        value: (_vm.ad.dwelling_type),
        callback: function($$v) {
          _vm.ad.dwelling_type = $$v
        },
        expression: "ad.dwelling_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Source'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.source),
        expression: "ad.source"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.source)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.source = $event.target.value
        }, _vm.set_ad_source]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_date'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.ad_date),
        expression: "ad.ad_date"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.ad_date)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.ad_date = $event.target.value
        }, _vm.set_ad_ad_date]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Capture_date'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.capture_date),
        expression: "ad.capture_date"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.capture_date)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.capture_date = $event.target.value
        }, _vm.set_ad_capture_date]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Url')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.url),
        expression: "ad.url"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.url)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.url = $event.target.value
        }, _vm.set_ad_url]
      }
    })]), _vm._v(" "), (_vm.ad.url) ? _c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenAd($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenAd($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Open')) + " " + _vm._s(_vm.$t('Ad')))], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Contact_telephone'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.contact_telephone),
        expression: "ad.contact_telephone"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.contact_telephone)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.contact_telephone = $event.target.value
        }, _vm.set_ad_contact_telephone]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Contact_name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.contact_name),
        expression: "ad.contact_name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.contact_name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.contact_name = $event.target.value
        }, _vm.set_ad_contact_name]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_code')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.ad_code),
        expression: "ad.ad_code"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.ad_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.ad_code = $event.target.value
        }, _vm.set_ad_ad_code]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Age')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Conservation_status')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_year'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.construction_year),
        expression: "ad.construction_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.construction_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.construction_year = $event.target.value
        }, _vm.set_ad_construction_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Last_renovation_year'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.last_renovation_year),
        expression: "ad.last_renovation_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.last_renovation_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.last_renovation_year = $event.target.value
        }, _vm.set_ad_last_renovation_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_age'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.adopted_age),
        expression: "ad.adopted_age"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.adopted_age)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.adopted_age = $event.target.value
        }, _vm.set_ad_adopted_age],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.conservation_statusValue,
        "options": _vm.conservation_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_conservation_status
      },
      model: {
        value: (_vm.ad.conservation_status),
        callback: function($$v) {
          _vm.ad.conservation_status = $$v
        },
        expression: "ad.conservation_status"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Areas')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.adopted_area),
        expression: "ad.adopted_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.adopted_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.adopted_area = $event.target.value
        }, _vm.set_ad_adopted_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_area')) + " (m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.built_area),
        expression: "ad.built_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.built_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.built_area = $event.target.value
        }, _vm.set_ad_built_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Land_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.land_area),
        expression: "ad.land_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.land_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.land_area = $event.target.value
        }, _vm.set_ad_land_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Net_area')) + " (m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.net_area),
        expression: "ad.net_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.net_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.net_area = $event.target.value
        }, _vm.set_ad_net_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Covered_outdoor_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.covered_outdoor_area),
        expression: "ad.covered_outdoor_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.covered_outdoor_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.covered_outdoor_area = $event.target.value
        }, _vm.set_ad_covered_outdoor_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Uncovered_outdoor_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.uncovered_outdoor_area),
        expression: "ad.uncovered_outdoor_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.uncovered_outdoor_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.uncovered_outdoor_area = $event.target.value
        }, _vm.set_ad_uncovered_outdoor_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Price')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Offer_price')) + " (€)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.offer_price),
        expression: "ad.offer_price"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.offer_price)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.offer_price = $event.target.value
        }, _vm.set_ad_offer_price],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Unit_price')) + " (€/m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.ad.offer_unit_price)) + " €/m²")])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Offer_price_reduction_coef')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.offer_price_reduction_pct),
        expression: "ad.offer_price_reduction_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.offer_price_reduction_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.offer_price_reduction_pct = $event.target.value
        }, _vm.set_ad_offer_price_reduction_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', [_vm._v(" Nota*")]), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v("Reducció per concepte d'Oferta, Comercialització, Negociació, etc.. per estimar el preu de venta final")])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Estimated_sale_price')) + " (€)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.ad.estimated_sale_price)) + " €")])])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Estimated_unit_sale_price')) + " (€)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.ad.estimated_unit_sale_price)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Features')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bedrooms_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.bedrooms_number),
        expression: "ad.bedrooms_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.bedrooms_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.bedrooms_number = $event.target.value
        }, _vm.set_ad_bedrooms_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bathrooms_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.bathrooms_number),
        expression: "ad.bathrooms_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.bathrooms_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.bathrooms_number = $event.target.value
        }, _vm.set_ad_bathrooms_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Parking_lots_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.parking_lots_number),
        expression: "ad.parking_lots_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.parking_lots_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.parking_lots_number = $event.target.value
        }, _vm.set_ad_parking_lots_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Orientation')) + " ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.orientation),
        expression: "ad.orientation"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.orientation)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.orientation = $event.target.value
        }, _vm.set_ad_orientation]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Air_conditioning'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.air_conditioning),
        expression: "ad.air_conditioning"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.air_conditioning) ? _vm._i(_vm.ad.air_conditioning, null) > -1 : (_vm.ad.air_conditioning)
      },
      on: {
        "input": _vm.set_ad_air_conditioning,
        "__c": function($event) {
          var $$a = _vm.ad.air_conditioning,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.air_conditioning = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.air_conditioning = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.air_conditioning = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('External_storage_room'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.external_storage_room),
        expression: "ad.external_storage_room"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.external_storage_room) ? _vm._i(_vm.ad.external_storage_room, null) > -1 : (_vm.ad.external_storage_room)
      },
      on: {
        "input": _vm.set_ad_external_storage_room,
        "__c": function($event) {
          var $$a = _vm.ad.external_storage_room,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.external_storage_room = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.external_storage_room = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.external_storage_room = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Green_areas'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.green_areas),
        expression: "ad.green_areas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.green_areas) ? _vm._i(_vm.ad.green_areas, null) > -1 : (_vm.ad.green_areas)
      },
      on: {
        "input": _vm.set_ad_green_areas,
        "__c": function($event) {
          var $$a = _vm.ad.green_areas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.green_areas = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.green_areas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.green_areas = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Heating'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.heating),
        expression: "ad.heating"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.heating) ? _vm._i(_vm.ad.heating, null) > -1 : (_vm.ad.heating)
      },
      on: {
        "input": _vm.set_ad_heating,
        "__c": function($event) {
          var $$a = _vm.ad.heating,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.heating = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.heating = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.heating = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Lift'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.lift),
        expression: "ad.lift"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.lift) ? _vm._i(_vm.ad.lift, null) > -1 : (_vm.ad.lift)
      },
      on: {
        "input": _vm.set_ad_lift,
        "__c": function($event) {
          var $$a = _vm.ad.lift,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.lift = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.lift = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.lift = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sports_facilities'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.sports_facilities),
        expression: "ad.sports_facilities"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.sports_facilities) ? _vm._i(_vm.ad.sports_facilities, null) > -1 : (_vm.ad.sports_facilities)
      },
      on: {
        "input": _vm.set_ad_sports_facilities,
        "__c": function($event) {
          var $$a = _vm.ad.sports_facilities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.sports_facilities = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.sports_facilities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.sports_facilities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Swimming_pool'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.swimming_pool),
        expression: "ad.swimming_pool"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.swimming_pool) ? _vm._i(_vm.ad.swimming_pool, null) > -1 : (_vm.ad.swimming_pool)
      },
      on: {
        "input": _vm.set_ad_swimming_pool,
        "__c": function($event) {
          var $$a = _vm.ad.swimming_pool,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.swimming_pool = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.swimming_pool = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.swimming_pool = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Interior_visit_check'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.interior_visit_check),
        expression: "ad.interior_visit_check"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.interior_visit_check) ? _vm._i(_vm.ad.interior_visit_check, null) > -1 : (_vm.ad.interior_visit_check)
      },
      on: {
        "input": _vm.set_ad_interior_visit_check,
        "__c": function($event) {
          var $$a = _vm.ad.interior_visit_check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.interior_visit_check = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.interior_visit_check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.interior_visit_check = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Qualities')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_neighbourhood'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_neighbourhoodValue,
        "options": _vm.quality_of_neighbourhoodOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_quality_of_neighbourhood
      },
      model: {
        value: (_vm.ad.quality_of_neighbourhood),
        callback: function($$v) {
          _vm.ad.quality_of_neighbourhood = $$v
        },
        expression: "ad.quality_of_neighbourhood"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_situation'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_situationValue,
        "options": _vm.quality_of_situationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_quality_of_situation
      },
      model: {
        value: (_vm.ad.quality_of_situation),
        callback: function($$v) {
          _vm.ad.quality_of_situation = $$v
        },
        expression: "ad.quality_of_situation"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_construction'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_constructionValue,
        "options": _vm.quality_of_constructionOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_quality_of_construction
      },
      model: {
        value: (_vm.ad.quality_of_construction),
        callback: function($$v) {
          _vm.ad.quality_of_construction = $$v
        },
        expression: "ad.quality_of_construction"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_realestate'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_realestateValue,
        "options": _vm.quality_of_realestateOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_quality_of_realestate
      },
      model: {
        value: (_vm.ad.quality_of_realestate),
        callback: function($$v) {
          _vm.ad.quality_of_realestate = $$v
        },
        expression: "ad.quality_of_realestate"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes_1')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.notes_1),
        expression: "ad.notes_1"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "15",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.notes_1)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.notes_1 = $event.target.value
        }, _vm.set_ad_notes_1]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes_2')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.notes_2),
        expression: "ad.notes_2"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "15",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.notes_2)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.notes_2 = $event.target.value
        }, _vm.set_ad_notes_2]
      }
    })])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.description),
        expression: "ad.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.description = $event.target.value
        }, _vm.set_ad_description]
      }
    })])])])])])])])], 1), _vm._v(" "), (!this.ad.lat || !this.ad.lng) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.epsg_missing_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.ad.geohash) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta el Geohash (Geolocalitzar)",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.ad.ad_type) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta indicar el tipus d'anunci",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.ad.ad_date) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta la data de l'anunci",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.ad.estimated_sale_price) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta el preu de venta estimat",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.ad.adopted_area) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta la superfície adoptada",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.manually_creating_new_ad) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoToMarketStudy($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "level-up",
        "text": _vm.go_to_market_study_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (!this.manually_creating_new_ad) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAd({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (!this.manually_creating_new_ad) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAd({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (this.manually_creating_new_ad && this.ad.lat && this.ad.lng && this.ad.geohash && this.ad.ad_type && this.ad.ad_date && this.ad.estimated_sale_price && this.ad.adopted_area) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onUploadCurrentAd({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.upload_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.ad.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('bar')], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1acbc018!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/ads/AdEditor.vue
// module id = 2115
// module chunks = 0